import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import * as Yup from "yup";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { languageOptions } from "../../utils/constants";
import { SlButton, SlDrawer } from "@shoelace-style/shoelace/dist/react";

const validationSchema = Yup.object({
  zone_name: Yup.string().required("Zone name is required"),
  lang_ids: Yup.string().required("Language is required"),
  state_ids: Yup.array().required("State is required"),
  district_ids: Yup.array().required("District is required"),
  constituency_ids: Yup.array().required("Constituency is required"),
});

function ZoneCreation({ show,setShow,loadData,editData,flag }) {
  const [constituencyOptions, setConstituencyOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors,isSubmitting }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      zone_name: "",
      lang_ids: '',
      state_ids: [],
      district_ids: [],
      constituency_ids: []
    },mode:'all'
  });

  // Watch form values for dependent fields
  const watchedValues = watch();
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const onSubmit = async (data) => {
    try {
        if(flag === 'add'){
            const res = await api({
                url: '/zones/creation',
                method: 'POST',
                responseType: 'json',
                data: {
                  ...data, lang_ids:[data.lang_ids]
                }
              });
              
              if (res.code === 200) {
                loadData()
                setShow(false)
                reset({
                    zone_name: "",
                    lang_ids: '',
                    state_ids: [],
                    district_ids: [],
                    constituency_ids: []
                  })
               Toast('success','Zones Created Successfully')
              }
        }
        else{
            const res = await api({
                url: '/zones/edit',
                method: 'POST',
                responseType: 'json',
                data: {
                  ...data, lang_ids:[data.lang_ids],zone_id:editData.zone_id
                }
              });
              
              if (res.code === 200) {
                loadData()
                setShow(false)
                reset({
                    zone_name: "",
                    lang_ids: '',
                    state_ids: [],
                    district_ids: [],
                    constituency_ids: []
                  })
               Toast('success','Zones Edited Successfully')
              }
        }
     
    } catch (error) {
      console.error(error);
      Toast('error', "Error while creating Zone");
    }
  };

  const lang_idsOnchange = async (selected, edit = false) => {
    let langs = [];
    if(Object.keys(selected).length){  
      if (typeof selected === 'object') {
        // If selected is an array of objects, extract the state_id from each object
        langs = [selected.value];
      } else {
        // If selected is an array of integers, use them directly
        langs = [selected];
      }
    }
    else{
        langs = [+selected]
    }
    
    try {
      const res = await api({
        url: '/location/getStatesByLangId',
        method: 'POST',
        responseType: 'json',
        data: langs
      });
      
      const states = [];
      for (let item of res.data) {
        const temp = { value: item, label: `${item.state_name}` };
        states.push(temp);
      }
      setStateOptions(states);
      
      if (!edit && !isInitialLoad) {
        setValue("state_ids", watchedValues.state_ids.filter((option) => langs.indexOf(option.lang_id) >= 0));
        setValue("district_ids", watchedValues.district_ids.filter((option) => langs.indexOf(option.lang_id) >= 0));
        setValue("constituency_ids", watchedValues.constituency_ids.filter((option) => langs.indexOf(option.lang_id) >= 0));
      }
      
      return states; // Return states for chaining
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const state_idsOnchange = async (selected, langs, edit = false) => {
    let states = [];
    if (selected.length > 0) {
      if (typeof selected[0] === 'object') {
        // If selected is an array of objects, extract the state_id from each object
        states = selected.map(item => item.value.state_id);
      } else {
        // If selected is an array of integers, use them directly
        states = selected;
      }
    }
    
    try {
      const res = await api({
        url: '/location/getDistrictsByStateId',
        method: 'POST',
        responseType: 'json',
        data: { states, langs }
      });
      
      const districts = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.dist_name}` };
        districts.push(temp);
      }
      setDistrictOptions(districts);
      
      if (!edit && !isInitialLoad) {
        const temp = [];
        setValue("district_ids", watchedValues.district_ids.filter((option) => {
          if (states.indexOf(option.state_id) >= 0) {
            temp.push(option.dist_id);
            return true;
          }
        }));
        setValue("constituency_ids", watchedValues.constituency_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0));
      }
      
      return districts; // Return districts for chaining
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const district_idsOnchange = async (selected, langs, edit = false) => {
    let districts = [];
    if (selected.length > 0) {
      if (typeof selected[0] === 'object') {
        // If selected is an array of objects, extract the state_id from each object
        districts = selected.map(item => item.value.dist_id);
      } else {
        // If selected is an array of integers, use them directly
        districts = selected;
      }
    }
    
    try {
      const consties = await api({
        url: `/location/getConstituentsnew`,
        method: 'POST',
        responseType: 'json',
        data: { districts, langs }
      });
      
      const constituents = [];
      for await (let item of consties.data) {
        const temp = { value: item, label: `${item.const_name}` };
        constituents.push(temp);
      }
      setConstituencyOptions(constituents);
      
      if (!edit && !isInitialLoad) {
        setValue("constituency_ids", watchedValues.constituency_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0));
      }
      
      return constituents; // Return constituencies for chaining
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getSelectValues = (options, field, fieldValue) => {
    if (options.length > 0 && fieldValue && Array.isArray(fieldValue)) {
      switch (field) {
        case "lang_ids":
          // fieldValue is array of strings/numbers
          return options.filter((option) => fieldValue.some(val => val === option.value));
        case "state_ids":
          // fieldValue is array of objects with state_id
          if (fieldValue.length > 0 && typeof fieldValue[0] === 'object') {
            const stateIds = fieldValue.map((option) => option.state_id);
            return options.filter((option) => stateIds.indexOf(option.value?.state_id) >= 0);
          } else {
            // fieldValue is array of objects (direct values)
            return options.filter((option) => fieldValue.some(val => val === option.value?.state_id));
          }
        case "district_ids":
          // fieldValue is array of objects with dist_id
          if (fieldValue.length > 0 && typeof fieldValue[0] === 'object') {
            const districtIds = fieldValue.map((option) => +option.dist_id);
            return options.filter((option) => districtIds.indexOf(+option.value?.dist_id) >= 0);
          } else {
            return options.filter((option) => fieldValue.some(val => val === option.value?.dist_id));
          }
        case "constituency_ids":
          // fieldValue is array of objects with const_id
          if (fieldValue.length > 0 && typeof fieldValue[0] === 'object') {
            const constituencyIds = fieldValue.map((option) => option.const_id);
            return options.filter((option) => constituencyIds.indexOf(option.value?.const_id) >= 0);
          } else {
            return options.filter((option) => fieldValue.some(val => val === option.value?.const_id));
          }
        default:
          return [];
      }
    } else {
      return [];
    }
  };
  // Handle package details autofill - FIXED VERSION
  useEffect(() => {
    const loadEditData = async () => {
        if(flag !== 'edit'){
            reset({})
            return
        }
      if (Object.keys(editData).length > 0) {
        setIsLoading(true);
        setIsInitialLoad(true);
        
        try {
          // Set basic form values first
          setValue('zone_name', editData.zone_name)
          setValue("lang_ids", editData.lang_id);
          
          // Load states and wait for completion
          const loadedStates = await lang_idsOnchange(editData.lang_id, true);
          
          // After states are loaded, set state values
          if (loadedStates.length > 0) {
            const stateValues = getSelectValues(loadedStates, 'state_ids', editData.state_ids);
            setValue("state_ids", stateValues.map(s => s.value));
            
            // Load districts and wait for completion
            const loadedDistricts = await state_idsOnchange(editData.state_ids, [editData.lang_id], true);
            
            // After districts are loaded, set district values
            if (loadedDistricts.length > 0) {
              const districtValues = getSelectValues(loadedDistricts, 'district_ids', editData.district_ids?.map(district_id => +district_id));
              setValue("district_ids", districtValues.map(d => d.value));
              
              // Load constituencies and wait for completion
              const loadedConstituencies = await district_idsOnchange(editData.district_ids, [editData.lang_id], true);
              
              // After constituencies are loaded, set constituency values
              if (loadedConstituencies.length > 0) {
                const constituencyValues = getSelectValues(loadedConstituencies, 'constituency_ids', editData.constituency_ids);
                setValue("constituency_ids", constituencyValues.map(c => c.value));
              }
            }
          }
          
          setIsInitialLoad(false);
          setIsLoading(false);
        } catch (error) {
          console.error("Error loading package details:", error);
          setIsInitialLoad(false);
          setIsLoading(false);
        }
      }
    };

    loadEditData();
  }, [flag, editData]);
  return (
    <>
    <SlDrawer open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={()=>{setShow(false)}} label="Zone Creation">
      <form onSubmit={handleSubmit(onSubmit)}>

      <div className="mb-3">
  <label htmlFor="zone_name" className="form-label">
    Zone Name
  </label>
  <span className="text-red-600">*</span>
  <Controller
    name="zone_name"
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <input
        id="zone_name"
        type="text"
        placeholder="Enter Zone Name"
        className="form-control"
        {...field}
      />
    )}
  />
  {errors.zone_name && (
    <div className="text-red-600 mt-1">Zone name is required</div>
  )}
</div>


        <h6 className="mt-2"> Targets</h6>
        
                <div className="mb-3">
        <label htmlFor="lang_ids" className="form-label">
            Language
        </label>
        <span className="text-red-600">*</span>

        <Controller
            name="lang_ids"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
            <Select
                aria-label="Language select"
                placeholder="Select language"
                value={languageOptions.find(opt => opt.value === field.value) || null}
                onChange={(selected) => {
                const value = selected ? selected.value : null;
                field.onChange(value);
                if (!isInitialLoad) {
                    lang_idsOnchange(selected);
                }
                }}
                options={[...languageOptions.slice(0, 2),{label:'Oria',value:10}]}
                isClearable
            />
            )}
        />

        {errors.lang_ids && (
            <div className="text-red-600 mt-1">Language is required</div>
        )}
        </div>

        <div className="mb-3">
          <label htmlFor="" className="form-label">
            State
          </label>
          <span className="text-red-600">*</span>
          <Controller
            name="state_ids"
            control={control}
            render={({ field }) => (
              <Select
                aria-label="Default select example"
                placeholder="Select States"
                value={getSelectValues(stateOptions, "state_ids", field.value || [])}
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  field.onChange(values);
                  if (!isInitialLoad) {
                    state_idsOnchange(selected, [watchedValues.lang_ids]);
                    // Trigger form submission after state change
                  }
                }}
                options={stateOptions}
                isMulti
                isLoading={isLoading}
              />
            )}
          />
          {errors.state_ids && (
            <div className="text-red-600">{'State was required'}</div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="" className="form-label">
            Districts
          </label>
          <Controller
            name="district_ids"
            control={control}
            render={({ field }) => (
              <Select
                aria-label="Default select example"
                placeholder="Select Districts"
                value={getSelectValues(districtOptions, "district_ids", field.value || [])}
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  field.onChange(values);
                  if (!isInitialLoad) {
                    district_idsOnchange(selected, [watchedValues.lang_ids]);
                    // Trigger form submission after district change
                  }
                }}
                options={districtOptions}
                isMulti
                isLoading={isLoading}
              />
            )}
          />
          {errors.district_ids && (
            <div className="text-red-600">{'District was required'}</div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="" className="form-label">
            Constituency
          </label>
          <Controller
            name="constituency_ids"
            control={control}
            render={({ field }) => (
              <Select
                aria-label="Default select example"
                placeholder="Select Constituency"
                value={getSelectValues(constituencyOptions, "constituency_ids", field.value || [])}
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  field.onChange(values);
                  if (!isInitialLoad) {
                    // Trigger form submission after constituency change
                  }
                }}
                options={constituencyOptions}
                isMulti
                isLoading={isLoading}
              />
            )}
          />
          {errors.constituency_ids && (
            <div className="text-red-600">{'Constituency was required'}</div>
          )}
        </div>
          <div className="mb-3">
                <SlButton type="submit" className="w-full" variant="primary" disabled={isSubmitting}>Submit</SlButton>
          </div>
    
      </form>
      </SlDrawer>
    </>
  );
}

export default ZoneCreation;